import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { App } from '@df/core/app';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { Subscription } from 'rxjs/internal/Subscription';
import { BasketDecorator } from '../customer/api/basket/basket.decorator';
import { ActionComponent } from '../ui/api/action.component';

@Component({
    selector: 'coupon-remove',
    templateUrl: './coupon-remove.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, PriceComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponRemoveComponent implements OnInit, OnDestroy {
    subscriptions = new Subscription();

    @Input()
    isCheckout = false;

    constructor(
        protected app: App,
        protected changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.basket.subscribe(() => this.detectChanges()));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get basket(): BasketDecorator {
        return <BasketDecorator>this.app.customer.basket;
    }

    get coupon(): string {
        const coupon = this.basket.data?.coupon;
        if (coupon) {
            return Array.isArray(coupon) ? coupon[0] : coupon;
        }
        return '';
    }

    get couponValue(): number {
        return this.basket.data?.totals?.discount;
    }

    get status() {
        return this.basket.removeCouponStatus;
    }

    remove(): void {
        this.basket.removeCoupon();
    }

    protected detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }
}
